import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService} from '../../master.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-add-profession',
  templateUrl: './add-profession.component.html',
  styleUrls: ['./add-profession.component.scss']
})
export class AddProfessionComponent implements OnInit {

  addProfessionForm: FormGroup;
  saveData={};
  shName='';
  searchCriteria={};
  profClassList=[];
  profGroupList=[]
  profDivisionList=[];
  partnerTypes=[];
  constructor(private formBuilder: FormBuilder,private masterService: MasterService,private route: ActivatedRoute,private loaderService:LoaderService,private toasterService: ToastrService, private router:Router) { 
    this.route.queryParams.subscribe(param =>{
      this.shName=param.masterShName;
      this.getAddprofessionForm();
      this.loadMasters();
    });
  }
  ngOnInit() {
  }
  loadMasters(){
    this.searchCriteria={};
    this.searchCriteria={
      masterShName:'DIVISION',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.profDivisionList = response['result'];
    })
    this.searchCriteria={
      masterShName:'CLASS',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.profClassList = response['result'];
    })
    this.searchCriteria={
      masterShName:'PROGROUP',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.profGroupList = response['result'];
    })
    if(this.shName=='ASSETTYPE'){
      this.masterService.getPartnerTypes().subscribe(response => {
        if (response && response['result']) {
          this.partnerTypes = response['result'];
        }
      })
    }
  }
  private getAddprofessionForm() {
    this.addProfessionForm = this.formBuilder.group({
      'id':[],
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl(),
      'code': new FormControl(),
      'description': new FormControl(),
      'descriptionFr': new FormControl(),
      'prclaId': new FormControl(),
      'prgrpId': new FormControl(),
      'prdivId': new FormControl(),
      'staRecCode': [true],
      'partnerType': new FormControl(),
          
    })
  }
  get f() {
    return this.addProfessionForm.controls;
  }
  saveMaster(){
    /* this.submitted = true;
    if (this.logisticsForm.invalid) {
      return;
    } */
    this.prepareSaveForm(this.shName);
    this.loaderService.display(true);
    this.masterService.saveMaster(this.saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"]==0) {
        this.toasterService.success(response['message'], 'Success');
      }else{
        this.toasterService.error(response['message'], 'Error');
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  prepareSaveForm(shName){
        let masterIp={
          id:this.f.id.value,
          code:this.f.code.value,
          codeInternational:this.f.codeInternational.value,
          codeLocal:this.f.codeLocal.value,
          descriptionFr:this.f.descriptionFr.value,
          description:this.f.description.value,
          staRecCode:this.f.staRecCode.value ? 'A' :'I'
        }
        if(shName=='PROFESSION'){
          masterIp['prclaId']=this.f.prclaId.value
        }else if(shName=='CLASS'){
          masterIp['prgrpId']=this.f.prgrpId.value
        }else  if(shName=='PROGROUP'){
          masterIp['prdivId']=this.f.prdivId.value
        }
        else  if(shName=='ASSETTYPE'){
          masterIp['partnerType']=this.f.partnerType.value
        }
        this.saveData={
          masterShName:shName,
          master:masterIp
        }
    
  }
  backToList(){    
    if(this.shName=='DIVISION'){   
      this.router.navigateByUrl('/profession?masterShName=DIVISION');
    }
    if(this.shName=='PROGROUP'){   
      this.router.navigateByUrl('/profession?masterShName=PROGROUP');
    }
    if(this.shName=='CLASS'){
      this.router.navigateByUrl('/profession?masterShName=CLASS');
    }
    if(this.shName=='PROFESSION'){
      this.router.navigateByUrl('/profession?masterShName=PROFESSION');
    }   
    if(this.shName=='ASSETTYPE'){
      this.router.navigateByUrl('/profession?masterShName=ASSETTYPE');
    } 
  }
 
  patchFormValues(result){
        this.addProfessionForm.patchValue({
          codeInternational:result["codeInternational"],
          codeLocal:result["codeLocal"],
          code:result["code"],
          description:result["description"],
          descriptionFr:result["descriptionFr"],
          prclaId:result["prclaId"],
          prgrpId:result["prgrpId"],
          prdivId:result["prdivId"],
          staRecCode:result["staRecCode"]!=null && result["staRecCode"]=='A' ? true: false,
          id:result["id"]});
  }
  reset(){
    this.addProfessionForm.reset();
  }
}
